import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../styles/AddStreak.css";
import openNotification from "components/utils/CustomNotification";

interface AddStreakProps {
  onClose?: () => void;
  onSuccess?: () => void;
}

const AddStreak: React.FC<AddStreakProps> = ({ onClose, onSuccess }) => {
  const [minCount, setMinCount] = useState<number>();
  const [maxCount, setMaxCount] = useState<number>();
  const [coins, setCoins] = useState<number>();
  const [orgUid, setOrgUid] = useState<string>("");

  const navigate = useNavigate();

  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";

  useEffect(() => {
    const fetchOrg = async () => {
      try {
        const response = await axios.get(`${beAddress}/api/org-info`, {
          headers: {
            "user-uid": userUid,
          },
          withCredentials: true,
        });

        if (response.status === 200 && response.data.data?.length > 0) {
          setOrgUid(response.data.data[0].org_uid);
        }
      } catch (err) {
        console.error("Error fetching org info:", err);
      }
    };

    fetchOrg();
  }, [beAddress, sessionUid, userUid]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // VALIDATION: Check if fields are empty/undefined before hitting API
    // Note: Since inputs parse to Number, we check for undefined.
    // Depending on your logic, you might also want to check if they are 0 or negative.
    if (
      minCount === undefined ||
      maxCount === undefined ||
      coins === undefined
    ) {
      openNotification({
        type: "error",
        message: "Please fill in all required fields marked with *",
      });
      return;
    }

    const streakData = {
      min_streak_count: minCount,
      max_streak_count: maxCount,
      reward_coins: coins,
    };

    try {
      const response = await axios.post(
        `${beAddress}/api/streak-config`,
        // {
        //   // org_uid: orgUid,
        //   streak_config_data: streakData,
        // },
        streakData,
        {
          headers: {
            "user-uid": userUid,
          },
          withCredentials: true,
        },
      );

      if (response.status === 200 && response.data?.status === "Success") {
        openNotification({
          type: "success",
          message: response.data.message,
        });
        if (onSuccess) onSuccess();
      } else {
        openNotification({
          type: "error",
          message: response.data.data,
        });
      }
    } catch (err: any) {
      console.error("Error adding streak config:", err);
    }
  };

  const blockInvalidChars = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <h2
        style={{
          textAlign: "center",
          marginBottom: "20px",
          fontSize: "22px",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        {" "}
        Add New Streak
      </h2>
      <form onSubmit={handleSubmit} className="add-streak-form">
        <label>
          <div className="labelnames">
            Min streak count <span style={{ color: "red" }}>*</span>:
          </div>
          <input
            type="number"
            min="0"
            max="99999999"
            value={minCount ?? ""}
            onChange={(e) => {
              if (e.target.value.length <= 8) {
                setMinCount(
                  e.target.value === "" ? undefined : Number(e.target.value),
                );
              }
            }}
            onKeyDown={blockInvalidChars}
            placeholder="Enter min count"
          />
        </label>

        <label>
          <div className="labelnames">
            Max streak count <span style={{ color: "red" }}>*</span>:
          </div>
          <input
            type="number"
            min="0"
            max="99999999"
            value={maxCount ?? ""}
            onChange={(e) => {
              if (e.target.value.length <= 8) {
                setMaxCount(
                  e.target.value === "" ? undefined : Number(e.target.value),
                );
              }
            }}
            onKeyDown={blockInvalidChars}
            placeholder="Enter max count"
          />
        </label>

        <label>
          <div className="labelnames">
            Reward coins on streak <span style={{ color: "red" }}>*</span>:
          </div>
          <input
            type="number"
            min="0"
            max="99999999"
            value={coins ?? ""}
            onChange={(e) => {
              if (e.target.value.length <= 8) {
                setCoins(
                  e.target.value === "" ? undefined : Number(e.target.value),
                );
              }
            }}
            onKeyDown={blockInvalidChars}
            placeholder="Enter coin amount"
          />
        </label>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          {/* Cancel Button */}
          <button
            type="button"
            className="cancel-btn"
            onClick={onClose}
            style={{
              flex: 1,
              backgroundColor: "#f5f5f5",
              color: "#333",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          {/* Submit Button */}
          <button type="submit" className="submit-btn" style={{ flex: 1 }}>
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default AddStreak;
